<template>
  <div>
    <CrudList
      title="Products"
      storeName="Products"
      parentStoreName="Companies"
      parentUrlKey="company_id"
      :canAdd="true"
      :canEdit="true"
      :canDelete="true"
      canSearch
      sortable
    >
      <template v-slot:verified="{ item }">
        <v-row align="center" justify="center">
          <v-col cols="8">
            <v-icon color="primary" v-if="typeof item.verified !== 'undefined' && item.verified">fas fa-check-circle</v-icon>
            <v-icon color="disabled" v-else>fas fa-times-circle</v-icon>
          </v-col>
        </v-row>
      </template>
      <template v-slot:bulk_actions="{ item }">
        <v-row>
          <v-col cols="1">
            <div>
              <v-checkbox
                  v-model="selected"
                  :value="item.id"
              >
              </v-checkbox>
            </div>
          </v-col>
        </v-row>
      </template>
      <template v-slot:prices="{ item }">
        <v-btn
            color="primary"
            @click="$router.push('/admin/companies/' + $route.params.company_id + '/products/' + item.id + '/product_prices')"
        >Prices
        </v-btn>
      </template>
      <template v-slot:picture="{ item }">
      <v-row align="center" justify="center">
        <v-col cols="12">
           <v-list-item-avatar v-if="item.picture">
             <img :src="item.picture" alt=""/>
           </v-list-item-avatar>
         </v-col>
      </v-row>
    </template>
    </CrudList>
    <DeleteConfirm
        :show="confirmDelete"
        :hide="hideConfirmDelete"
        :submit="confirmDeleteItems"
        title="Delete Record"
        description="Are you sure to delete this record(s)?"
    />
  </div>
</template>

<script>
  import CrudList from "@/components/Crud/CrudList";
  import DeleteConfirm from "@/components/Crud/Modals/Confirm";

  export default {
    components: {CrudList, DeleteConfirm},
    data() {
      return {
        selected: [],
        count: null,
        confirmDelete: false,
      };
    },
    methods: {
      deleteItems() {
        this.confirmDelete = true;
      },
      hideConfirmDelete() {
        this.confirmDelete = false;
      },
      confirmDeleteItems() {
        this.submit('delete')
      },
    },
    computed: {
    }
  };
</script>
